export default {
    formList:'/pms/pms/formtemplate/list',
    detail:'/pms/pms/formtemplate/get',
    saveForm:'/pms/pms/formtemplate/save',
    deleteForm:'/pms/pms/formtemplate/del'
}